<template>
  <div id="groupOrder">
    <div class="lv3Text container t">填写订单信息</div>
    <div class="box container">
      <div align="right" style="padding:10px 20px 0 0; ">
        <router-link to="/user/address/0">
          <el-button type="text" size="small">
            <i class="fas fa-edit"></i> 管理收货地址
          </el-button>
        </router-link>
      </div>
      <div class="lv2Text box2">
        <div v-if="_.size(addressList)>0">
          <el-row>
            <el-col :span="12">
              <div class="r1">
                <span class="lv3Text l1">收件人：</span>
                <span>{{address.name}}</span>
              </div>
              <div class="r1">
                <span class="lv3Text l1">联系电话：</span>
                <span>{{address.mobile}}</span>
              </div>
              <div class="r1">
                <span class="lv3Text l1">收货地址：</span>
                <span>{{address.province+" "+address.city+" "+address.area}}</span>
                <div style="margin-left:80px;margin-top:5px;">{{address.address}}</div>
              </div>
            </el-col>
            <el-col :span="12">
              <div>
                <el-popover placement="bottom-end" width="600" trigger="click" v-model="v">
                  <div>
                    <div v-for="(item,index) of addressList" :key="index">
                      <div style="border-bottom:1px solid #ddd;margin-bottom:10px;">
                        <el-row>
                          <el-col :span="21">
                            <div>
                              <div style="margin-bottom:10px;">{{item.name}} {{item.mobile}}</div>
                              <div
                                style="margin-bottom:10px;"
                              >{{item.province+" "+item.city+" "+item.area+" "+item.address}}</div>
                            </div>
                          </el-col>
                          <el-col :span="3">
                            <div align="right">
                              <el-button plain size="mini" @click="changeAddress(item.id)">使用</el-button>
                            </div>
                          </el-col>
                        </el-row>
                      </div>
                    </div>
                  </div>
                  <el-button plain size="mini" class="btn1" slot="reference">
                    更改地址
                    <i class="fas fa-caret-down"></i>
                  </el-button>
                </el-popover>
              </div>
            </el-col>
          </el-row>
        </div>
        <div v-else class="lv3Text">
          未设置收货地址，去
          <el-link type="primary" @click="addFn() ">添加收货地址</el-link>
        </div>
      </div>
      <div style="padding: 0 20px;margin-bottom:30px">
        <el-table border :data="[tableData]" style="width: 100%">
          <el-table-column width="80">
            <template slot-scope="scope">
              <img :src="serve +scope.row.images" class="cover" />
            </template>
          </el-table-column>
          <el-table-column label="商品信息">
            <template slot-scope="scope">
              <div class="lv2Text">{{scope.row.title}}</div>
              <div class="lv3Text">货号：{{scope.row.item_no}}</div>
            </template>
          </el-table-column>
          <el-table-column label="价格" width="90">
            <template slot-scope="scope">
              <div class="lv0Text">&yen;{{scope.row.price}}</div>
            </template>
          </el-table-column>
          <el-table-column label="数量" width="90">
            <template slot-scope="scope">
              <div class="lv3Text">x{{scope.row.number}}</div>
            </template>
          </el-table-column>
          <el-table-column label="小计" width="90">
            <template slot-scope="scope">
              <div class="lv0Text">&yen;{{scope.row.price*scope.row.number}}</div>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="lv3Text t2">支付方式</div>
      <div class="box2">
        <div class="btn4_active lv3Text">在线付款</div>
      </div>
      <div class="lv3Text t2">开票信息</div>
      <div class="box2">
        <div :class="InvoiceId!=0?'btn4_active lv3Text':'btn4 lv3Text'" @click="show_invoice()">
          <div :class="InvoiceId!=0?'hide':''">
            <i class="far fa-square fa-lg"></i>
            是否开票
          </div>
          <div :class="InvoiceId==0?'hide':''">
            <i class="far fa-check-square fa-lg"></i>
            是否开票
          </div>
        </div>
      </div>
      <div class="lv3Text t2">订单信息</div>
      <div class="lv2Text t3">
        <div>
          <span class="l2">商品总数：</span>
          <span class="l3">{{tableData.number}}件</span>
        </div>
        <div>
          <span class="l2">商品总价：</span>
          <span class="l3">&yen;{{tableData.price}}</span>
        </div>
        <div>
          <span class="l2">活动优惠：</span>
          <span class="l3">&yen;0</span>
        </div>
        <div>
          <span class="l2">运费：</span>
          <!-- <span class="l3">&yen;{{tableData.price*tableData.number>500?0:20}}</span> -->
          <span class="l3">&yen;0</span>
        </div>
        <div style="font-size:20px;margin-top:20px;margin-bottom:20px">
          <span class="l2">应付总额：</span>
          <!-- <span
            class="l3 lv0Text"
          >&yen;{{tableData.price*tableData.number>500?tableData.price*tableData.number:((tableData.price*tableData.number)+20)}}</span>-->
          <span
            class="l3 lv0Text"
          >&yen;{{tableData.price*tableData.number>500?tableData.price*tableData.number:((tableData.price*tableData.number)+0)}}</span>
        </div>
      </div>
    </div>

    <div style="padding: 30px 0;" class="container" align="right">
      <el-button type="primary" style="width: 150px;" @click="submit">提交订单</el-button>
    </div>

    <el-dialog title="开票信息" :visible.sync="invoiceV" width="40%">
      <div>
        <div align="center" style="padding-bottom: 20px;">
          <el-radio-group v-model="form.type" size="medium">
            <el-radio-button label="普通发票"></el-radio-button>
            <el-radio-button label="增值税发票"></el-radio-button>
          </el-radio-group>
        </div>
        <el-form label-position="right" label-width="200px" v-if="form.type=='普通发票'">
          <el-form-item label="发票抬头：">
            <el-radio-group v-model="form.type1" size="medium">
              <el-radio-button label="单位"></el-radio-button>
              <el-radio-button label="个人"></el-radio-button>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.type1!='单位'">
            <el-input v-model="form.name" placeholder="填写个人发票名称" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item v-if="form.type1 =='单位'">
            <el-autocomplete
              style="width:300px"
              class="inline-input"
              v-model="form.name"
              placeholder="填写单位名称"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>

            <br />
            <el-input
              v-model="form.tax_number"
              placeholder="填写纳税人识别号"
              style="width:300px;margin-top:20px"
            ></el-input>
          </el-form-item>
          <el-form-item label="自定义：" v-if="form.content=='自定义'">
            <el-input v-model="form.content2" placeholder="自定义开票内容" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="收票人姓名：">
            <el-input v-model="form.invoice_name" placeholder="填写发票收货人姓名" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="收票人电话：">
            <el-input v-model="form.invoice_mobile" placeholder="填写发票收货人手机号" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="收票人地址：">
            <el-input v-model="form.address" placeholder="填写发票收货地址" style="width:300px"></el-input>
          </el-form-item>
        </el-form>
        <el-form align="left" label-position="right" label-width="200px" v-if="form.type=='增值税发票'">
          <el-form-item label="自定义：" v-if="form.content=='自定义'">
            <el-input v-model="form.content2" placeholder="自定义开票内容" style="width:300px"></el-input>
          </el-form-item>
          <el-form-item label="单位名称：">
            <el-autocomplete
              style="width:400px"
              class="inline-input"
              v-model="form.name"
              placeholder="填写单位名称"
              :fetch-suggestions="querySearch"
              :trigger-on-focus="false"
              @select="handleSelect"
            ></el-autocomplete>
          </el-form-item>
          <el-form-item label="纳税人识别号：">
            <el-input v-model="form.tax_number" placeholder="填写纳税人识别号" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="注册地址：">
            <el-input v-model="form.register_address" placeholder="填写注册地址" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="注册电话：">
            <el-input v-model="form.register_phone" placeholder="填写注册电话" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="开户银行：">
            <el-input v-model="form.open_user_bank" placeholder="填写开户银行" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="银行账户：">
            <el-input v-model="form.open_card_number" placeholder="填写银行账户" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="收票人姓名：">
            <el-input v-model="form.invoice_name" placeholder="填写收票人姓名" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="收票人电话：">
            <el-input v-model="form.invoice_mobile" placeholder="填写收票人电话" style="width:400px"></el-input>
          </el-form-item>
          <el-form-item label="收票地址：">
            <el-input v-model="form.address" placeholder="填写收票地址" style="width:400px"></el-input>
          </el-form-item>
        </el-form>
        <div align="center" style="padding: 20px 0 20px 0;">
          <el-button @click="invoiceV = false">取消</el-button>
          <el-button type="primary" @click="submitInvoice" :loading="iLoading">确定</el-button>
        </div>
      </div>
    </el-dialog>
    <el-dialog title="添加收货地址" :visible.sync="addDialog" width="50%" @closed="handleClose">
      <div>
        <el-row :gutter="40" class="row">
          <el-col :span="12">
            <el-input v-model="addform.name" placeholder="请输入姓名"></el-input>
          </el-col>
          <el-col :span="12">
            <el-input v-model="addform.a_mobile" placeholder="请输入手机号"></el-input>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="row">
          <el-col :span="8">
            <el-select v-model="addform.province" placeholder="请选择" @change="change1">
              <el-option
                v-for="(item,index) in sel1"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.city" placeholder="请选择" @change="change2">
              <el-option
                v-for="(item,index) in sel2"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="8">
            <el-select v-model="addform.area" placeholder="请选择">
              <el-option
                v-for="(item,index) in sel3"
                :key="index"
                :label="item.name"
                :value="item.name"
              ></el-option>
            </el-select>
          </el-col>
        </el-row>
        <el-row class="row">
          <el-col :span="24">
            <el-input type="textarea" v-model="addform.address" placeholder="请输入详细地址"></el-input>
          </el-col>
        </el-row>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addDialog = false">取 消</el-button>
        <el-button type="primary" @click="addsubmit" :loading="loading">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,

      options: [
        {
          value: "试剂"
        },
        {
          value: "设备"
        },
        {
          value: "耗材"
        },
        {
          value: "抗体"
        },
        {
          value: "仪器"
        },
        {
          value: "技术服务"
        },
        {
          value: "其他"
        },
        {
          value: "自定义"
        }
      ],
      address: "",
      addressList: "",
      form: {
        type1: "单位",
        address_id: "",
        type: "普通发票",
        invoice_mobile: "15618372651",
        paytype: 1
      },
      v: false,
      tableData: {
        title: decodeURIComponent(this.$route.query.title),
        number: this.$route.query.number,
        item_no: this.$route.query.item_no,
        id: this.$route.query.id,
        p_id: this.$route.query.id,
        images: this.$route.query.images,
        price: this.$route.query.price,
        group_id: this.$route.query.group_id,
        f_group_id: this.$route.query.f_group_id
      },
      invoiceV: false,
      selectArr: [],
      InvoiceId: 0,
      iLoading: false,
      addform: {},
      addDialog: false,
      sel1: null,
      sel2: null,
      sel3: null,
      loading: false
    };
  },
  created() {
    this.initData();
  },
  activated() {
    this.initData();
  },
  methods: {
    //.
    handleSelect(item) {
      this.form.tax_number = item.address;
    },
    querySearch(queryString, cb) {
      this.axios
        .get(this.serve+"/member/duty_code", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            company: queryString
          }
        })
        .then(res => {
          this.restaurants = [];
          for (var item of res.data) {
            this.restaurants.push({
              value: item.company_name,
              address: item.duty_code
            });
          }
          cb(this.restaurants);
        });
    },
    show_invoice() {
      if (this.addressList.length == 0) {
        this.$message({
          showClose: true,
          type: "error",
          message: "请填写收货地址",
          offset: 400
        });
        return;
      }
      this.invoiceV = true;
      // 是否存在历史记录
      this.axios
        .get(this.serve+"/member/last_invoice", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          var _this = this;
          if (res.data.status == "success") {
            var json = res.data.data;
            json.paytype = this.form.paytype;
            json.address_id = this.form.address_id;
            if (json.type == "1") {
              json.type = "普通发票";
            } else if (json.type == "2") {
              json.type = "增值税发票";
            }
            if (json.type1 == "1") {
              json.type1 = "个人";
            } else if (json.type1 == "2") {
              json.type1 = "单位";
            }
            _this.form = json;
          } else {
            var address = this.address;
            this.invoiceV = true;
            this.form.invoice_name = address.name;
            this.form.invoice_mobile = address.mobile;
            this.form.address =
              address.province + address.city + address.area + address.address;
          }
        });
    },
    handleClose() {
      this.addform = {};
    },
    addsubmit() {
      this.loading = true;
      this.addform.mobile = this.$cookies.get("user");
      this.addform.token = this.$cookies.get("token");
      this.axios
        .get(this.serve+"/member/add_address", {
          params: this.addform
        })
        .then(res => {
          this.addDialog = false;
          this.loading = false;
          if (res.data.status == "success") {
            this.$message({
              showClose: true,
              type: "success",
              message: "添加了一个新的收货地址",
              offset: 400
            });

            this.initData();
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    change1(v) {
      this.axios.get(this.serve+"/city?name=" + v).then(res => {
        this.sel2 = res.data;
      });
    },
    change2(v) {
      this.axios.get(this.serve+"/area?name=" + v).then(res => {
        this.sel3 = res.data;
      });
    },
    addFn() {
      this.axios.get(this.serve+"/province").then(res => {
        this.sel1 = res.data;
        this.addDialog = true;
      });
    },
    submit() {
      var formdata = new FormData();
      formdata.append("mobile", this.$cookies.get("user"));
      formdata.append("token", this.$cookies.get("token"));
      formdata.append("f_group", this.tableData.f_group_id);
      formdata.append("address_id", this.address.id);
      formdata.append("number", this.tableData.number);
      formdata.append("invoice_id", this.InvoiceId);
      for (var pair of formdata.entries()) {
        // console.log(pair[0] + ", " + pair[1]);
      }
      let config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios
        .post(
          this.serve+"/member/join_group_order",
          formdata,
          config
        )
        .then(res => {
          if (res.data.status == "success") {
            this.$router.push("/user/pay?order=" + res.data.data);
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    submitInvoice() {
      this.iLoading = true;
      var formdata = new FormData();
      formdata.append("mobile", this.$cookies.get("user"));
      formdata.append("token", this.$cookies.get("token"));

      if (this.form.type == "普通发票") {
        formdata.append("type", "1");
      } else if (this.form.type == "增值税发票") {
        formdata.append("type", "2");
      }
      formdata.append("invoice_name", this.form.invoice_name);
      formdata.append("invoice_mobile", this.form.invoice_mobile);
      formdata.append("address", this.form.address);
      if (this.form.type == "普通发票") {
        formdata.append("name", this.form.name);
        if (this.form.content == "自定义") {
          formdata.append("content", this.form.content2);
        } else {
          formdata.append("content", this.form.content);
        }
        if (this.form.type1 == "单位") {
          formdata.append("type1", "2");
          formdata.append("tax_number", this.form.tax_number);
        } else if (this.form.type1 == "个人") {
          formdata.append("type1", "1");
        }
      } else if (this.form.type == "增值税发票") {
        if (this.form.content == "自定义") {
          formdata.append("content", this.form.content2);
        } else {
          formdata.append("content", this.form.content);
        }
        formdata.append("name", this.form.name);
        formdata.append("tax_number", this.form.tax_number);
        formdata.append("register_address", this.form.register_address);
        formdata.append("register_phone", this.form.register_phone);
        formdata.append("open_user_bank", this.form.open_user_bank);
        formdata.append("open_card_number", this.form.open_card_number);
      }

      for (var pair of formdata.entries()) {
        // console.log(pair[0] + ", " + pair[1]);
      }

      let config = { headers: { "Content-Type": "multipart/form-data" } };
      this.axios
        .post(
          this.serve+"/member/create_invoice",
          formdata,
          config
        )
        .then(res => {
          this.iLoading = false;
          if (res.data.status == "success") {
            this.InvoiceId = res.data.data;
            this.$message({
              showClose: true,
              message: "开票信息已保存",
              offset: 400
            });

            this.invoiceV = false;
          } else {
            this.$message({
              showClose: true,
              type: "error",
              message: res.data.msg,
              offset: 400
            });
          }
        });
    },
    changeAddress(i) {
      this.form.address_id = i;
      for (var item of this.addressList) {
        if (item.id == i) {
          this.address = item;
        }
      }
      this.v = false;
    },
    initData() {
      this.axios
        .get(this.serve+"/member/get_default_address2", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.address = res.data.data;
        });

      this.axios
        .get(this.serve+"/member/get_address", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.addressList = res.data.data.results;
        });
    }
  }
};
</script>
<style lang="scss">
#groupOrder {
  .l3 {
    display: inline-block;
    width: 80px;
  }
  .t3 {
    padding: 20px;
    line-height: 1.5em;
    text-align: right;
  }
  .hide {
    display: none;
  }
  .s-item {
    border: 1px solid #ddd;
    border-radius: 5px;
    width: 90px;
    text-align: center;
    display: inline-block;
    margin-right: 10px;
    margin-bottom: 10px;
    cursor: pointer;
  }
  .btn4 {
    cursor: pointer;
    border: 2px solid #cccccc;
    padding: 10px 60px;
    display: inline-block;
    border-radius: 5px;
    color: #cccccc;
    background-color: #f5f5f5;
  }
  .btn4_active {
    cursor: pointer;
    border: 2px solid #e2211c;
    padding: 10px 60px;
    display: inline-block;
    border-radius: 5px;
    color: #e2211c;
    background-color: #f5f5f5;
  }
  .t2 {
    padding: 10px 20px;
  }
  .cover {
    width: 100%;
  }
  .btn1 {
    float: right;
    position: absolute;
    top: 50%;
    right: 0;
    margin-top: -14px;
  }
  padding-bottom: 50px;
  .r1 {
    margin-bottom: 10px;
  }
  .l1 {
    width: 80px;
    display: inline-block;
  }
  .t {
    padding: 20px 0;
  }
  .box {
    background-color: #fff;
    border: 1px solid #ddd;
  }
  .box2 {
    border: 1px solid #ddd;
    padding: 20px;
    margin: 20px;
  }
}
</style>